import React from "react"
import { graphql } from "gatsby"
import Card from "../components/ui/card/Card"
// import Breadcrumb from "../components/ui/breadcrumb/Breadcrumb"

export default function Category({ data: { category, products } }) {
  const allProducts = products.nodes
  return (
    <div>
      {/* <Breadcrumb cateSlug={category.slug.current} category={category.title} /> */}
      <div className="flex justify-center mb-10">
        <h2 className="pl-3 text-2xl font-bold underline">
          Category:{category.title}
        </h2>
      </div>

      <div className="w-full pb-1 ">
        {allProducts.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 -mt-0.5">
            {allProducts.map(product => {
              if (product.hide) {
                return <></>
              }
              return <Card product={product} key={product._id} />
            })}
          </div>
        ) : (
          <div>
            <h2 className="text-2xl p-4 lg:p-20  col-span-2">
              No Products are found!!!
            </h2>
          </div>
        )}
      </div>
    </div>
  )
}

export const query = graphql`
  query ($id: String!) {
    category: sanityCategory(id: { eq: $id }) {
      title
      slug {
        current
      }
      image {
        asset {
          gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
        }
      }
    }
    products: allSanityProduct(
      filter: { subcategory: { category: { id: { eq: $id } } } }
    ) {
      nodes {
        ...ProductCard
      }
    }
  }
`
